import { $ } from './dom';

export interface ToastOptions {
  color?: string;
  action?: { label: string; run: () => void };
  /** Stays until dismissed or its action is used. */
  sticky?: boolean;
  duration?: number;
}

export function toast(msg: string, opts: ToastOptions | string = {}) {
  const o: ToastOptions = typeof opts === 'string' ? { color: opts } : opts;
  const box = $('#toasts');
  const t = document.createElement('div');
  t.className = 'toast';
  const dot = document.createElement('i');
  dot.className = 'dot';
  const text = document.createElement('span');
  text.textContent = msg;
  t.append(dot, text);
  if (o.color) t.style.setProperty('--tc', o.color);

  const dismiss = () => {
    if (t.classList.contains('out')) return;
    t.classList.add('out');
    setTimeout(() => t.remove(), 320);
  };
  if (o.action) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'toast-act';
    b.textContent = o.action.label;
    b.addEventListener('click', () => {
      o.action!.run();
      dismiss();
    });
    t.append(b);
  }
  if (o.sticky) {
    const x = document.createElement('button');
    x.type = 'button';
    x.className = 'toast-x';
    x.setAttribute('aria-label', 'Dismiss');
    x.textContent = '×';
    x.addEventListener('click', dismiss);
    t.append(x);
  }
  box.appendChild(t);
  const live = [...box.children].filter((c) => !c.classList.contains('out') && !c.querySelector('.toast-x'));
  if (live.length > 3) live[0]!.remove();
  if (o.sticky) return;
  const ms = o.duration ?? (o.action ? 6000 : 3400);
  let timer = setTimeout(dismiss, ms);
  if (o.action) {
    // Never time out under the user's pointer or keyboard focus (WCAG 2.2.1).
    let hovered = false;
    const hold = () => clearTimeout(timer);
    const resume = () => {
      if (hovered || t.contains(document.activeElement)) return;
      clearTimeout(timer);
      timer = setTimeout(dismiss, 3000);
    };
    t.addEventListener('pointerenter', () => {
      hovered = true;
      hold();
    });
    t.addEventListener('pointerleave', () => {
      hovered = false;
      resume();
    });
    t.addEventListener('focusin', hold);
    t.addEventListener('focusout', () => setTimeout(resume));
  }
}
